var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3 3 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "android") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M13.8 6.88l0.68-1.080c0.24-0.4 0.12-0.92-0.28-1.16s-0.92-0.12-1.16 0.28l-0.76 1.2c-0.76-0.28-1.56-0.44-2.36-0.44-0.84 0-1.64 0.16-2.36 0.44l-0.76-1.2c-0.24-0.4-0.76-0.52-1.16-0.28s-0.52 0.76-0.28 1.16l0.68 1.080c-1.84 1.24-3.080 3.36-3.080 5.76v8.72c0 1.28 1.040 2.32 2.32 2.32h1.56l0.040 2.96c0 0.48 0.4 0.84 0.84 0.84 0 0 0 0 0 0 0.48 0 0.84-0.4 0.84-0.84l-0.040-2.96h2.68l0.040 2.96c0 0.48 0.4 0.84 0.84 0.84 0 0 0 0 0 0 0.48 0 0.84-0.4 0.84-0.84l-0.040-2.96h1.6c1.28 0 2.32-1.040 2.32-2.32v-8.72c0.080-2.4-1.12-4.52-3-5.76zM9.92 7.4c2.6 0 4.8 1.92 5.2 4.4h-10.4c0.4-2.52 2.6-4.4 5.2-4.4zM14.56 22h-9.28c-0.36 0-0.64-0.28-0.64-0.64v-7.88h10.56v7.88c0 0.36-0.32 0.64-0.64 0.64zM19.84 13.4v6.2c0 0.48-0.4 0.84-0.84 0.84s-0.84-0.4-0.84-0.84v-6.2c0-0.48 0.4-0.84 0.84-0.84s0.84 0.36 0.84 0.84zM1.72 13.4v6.2c0 0.48-0.4 0.84-0.84 0.84s-0.88-0.36-0.88-0.84v-6.2c0-0.48 0.4-0.84 0.84-0.84s0.88 0.36 0.88 0.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.84a9db74.svg";
export { ForwardRef as ReactComponent };